import cx from "classnames";
import { useTranslation } from "next-i18next";
import React from "react";

import { Icon } from "@/components/elements/Icon";

import styles from "./styles.module.css";

export type ButtonCloseProps = {
  onClick: () => void;
  label?: string;
  className?: string;
};

export const ButtonClose = ({
  onClick,
  label = "close_CTA",
  className,
}: ButtonCloseProps) => {
  const { t } = useTranslation();
  const ariaLabel = t(label);
  return (
    <button
      className={cx(styles.container, className)}
      aria-label={ariaLabel}
      onClick={onClick}
      type="button"
    >
      <Icon type="close" label={ariaLabel} />
    </button>
  );
};
